<template>
  <section class="pmp-summary-card">
    <div class="pmp-section-head">
      <div>
        <h1 class="pmp-summary-title">Confirma tu información</h1>
      </div>
    </div>

    <div class="pmp-summary-list">
      <!-- Producción -->
      <div class="pmp-summary-row">
        <i class="bi bi-calendar3" aria-hidden="true"></i>
        <span>Fecha y hora</span>
        <strong>{{ fechaHoraLabel }}</strong>
      </div>

      <div class="pmp-summary-row">
        <i class="bi bi-person" aria-hidden="true"></i>
        <span>Operador</span>
        <strong>{{ form.operadorLabel || "—" }}</strong>
      </div>

      <div class="pmp-summary-row">
        <i class="bi bi-cpu" aria-hidden="true"></i>
        <span>Máquina / Producto</span>
        <strong>{{ maquinaProductoLabel }}</strong>
      </div>

      <!-- Producto -->
      <div class="pmp-summary-row">
        <i class="bi bi-palette" aria-hidden="true"></i>
        <span>Color / Mezcla</span>
        <strong>{{ mezclaLabel }}</strong>
      </div>

      <div class="pmp-summary-row">
        <i class="bi bi-droplet" aria-hidden="true"></i>
        <span>Aditivo</span>
        <strong>{{ aditivoLabel }}</strong>
      </div>

      <!-- TPU -->
      <div class="pmp-summary-row pmp-summary-row--stacked">
        <i class="bi bi-box-seam" aria-hidden="true"></i>
        <span>TPU</span>
        <strong class="pmp-summary-stack">
          <template v-if="form.tpuItems?.length">
            <span v-for="(item, index) in form.tpuItems" :key="item.id">
              <small v-if="form.tpuItems.length > 1">{{ index + 1 }}.</small>
              {{ tpuItemLabel(item) }}
            </span>
          </template>
          <span v-else>Sin TPU</span>
        </strong>
      </div>

      <!-- Molida -->
      <div class="pmp-summary-row">
        <i class="bi bi-recycle" aria-hidden="true"></i>
        <span>Molida</span>
        <strong>
          {{ molidaLabel }}
        </strong>
      </div>

      <!-- Comentarios -->
      <div class="pmp-summary-row pmp-summary-row--long">
        <i class="bi bi-chat-left-text" aria-hidden="true"></i>
        <span>Observaciones</span>
        <strong>{{ form.comentarios || "Sin observaciones" }}</strong>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  form: {
    type: Object,
    required: true,
  },
  formatGr: {
    type: Function,
    required: true,
  },
});

const molidaLabel = computed(() => {
  if (props.form.molidaCantidad === "" || props.form.molidaCantidad == null) {
    return "No registrada";
  }

  return `${props.form.molidaCantidad} ${
    props.form.molidaUnidadLabel || props.form.molidaUnidad
  }`;
});

const fechaHoraLabel = computed(() => {
  const fecha = props.form.fecha || "—";
  const hora = props.form.hora || "—";

  return `${fecha} · ${hora}`;
});

const maquinaProductoLabel = computed(() => {
  const maquina = props.form.maquinaLabel || "—";
  const producto = props.form.productoLabel || "—";

  return `${maquina} · ${producto}`;
});

const mezclaLabel = computed(() => {
  const color = props.form.colorLabel || "—";
  const pigmento = `${props.formatGr(props.form.cantidadPigmentoGr)} gr`;
  return `${color} · ${pigmento}`;
});

const aditivoLabel = computed(() => {
  if (props.form.aditivo === true) return "Sí lleva aditivo";
  if (props.form.aditivo === false) return "No lleva aditivo";
  return "—";
});

function tpuItemLabel(item) {
  const proveedor = item.proveedorLabel || "—";
  const cantidad = item.cantidad || 0;
  const unidad = item.unidadLabel || item.unidad || "";

  return `${proveedor} · ${cantidad} ${unidad}`.trim();
}
</script>
